import { useId, type CSSProperties } from 'react'

/** Yorqinligi 0,8 dan past har nuqta qora, qolgani qog'oz rangi — termal printer kulrang bosa olmaydi. */
const THRESHOLD = '0 0 0 0 1'

interface ThermalLogoProps {
  src: string
  alt?: string
  style?: CSSProperties
  onError?: () => void
}

export function ThermalLogo({ src, alt = '', style, onError }: ThermalLogoProps) {
  const filterId = `thermal-${useId().replace(/:/g, '')}`
  return (
    <>
      <svg width="0" height="0" aria-hidden="true" focusable="false" style={{ position: 'absolute' }}>
        <filter id={filterId} colorInterpolationFilters="sRGB">
          <feColorMatrix type="saturate" values="0" />
          <feComponentTransfer>
            <feFuncR type="discrete" tableValues={THRESHOLD} />
            <feFuncG type="discrete" tableValues={THRESHOLD} />
            <feFuncB type="discrete" tableValues={THRESHOLD} />
          </feComponentTransfer>
        </filter>
      </svg>
      <img src={src} alt={alt} onError={onError} style={{ ...style, filter: `url(#${filterId})` }} />
    </>
  )
}
